"use client";

import { useAccountIdMonitor } from "../hooks/useAccountIdMonitor";

/**
 * Component that monitors the currentAccountId cookie and automatically
 * logs the user out if the cookie changes or is deleted.
 *
 * This component should be placed inside the authenticated area of the app
 * to ensure it only runs when the user is logged in.
 */
export function AccountIdMonitor() {
  // The hook handles all the monitoring logic
  useAccountIdMonitor();

  // This component doesn't render anything
  return null;
}
